// 常量: 主题/事件
export const PRICING_DATA_PERIOD_MODIFIED = 'waterfee-pricing-data-period-modified'
export const PRICING_DATA_STAIRSTEP_MODIFIED = 'waterfee-pricing-data-stairstep-modified'
export const PAYMENT_PAID = 'waterfee-payment-paid'



// WEBPACK FOOTER //
// ./src/sysmodule/waterfee/topics.js